import DashBannerTablet from './dash-banner-tablet';

export default DashBannerTablet;
